import { Game } from './Game.js';

const game = new Game();
game.init();
